import { releaseService } from "@/app/providers/services";
import { releaseWithWorkingGraph } from "@imminently/decisively-core";
import type { Release } from "@packages/commons";

/**
 * A release with its rule graph, which the releases service sends as the release's compiled decision graph
 * (`decisionGraph`; GET releases/<id>?graph=dg). `rule_graph` is the working graph read from it: a DecisionGraph,
 * not JSON. Read it with DecisionGraph's id API (DecisionGraph.from(rule_graph) gives it as it is, and still takes
 * the JSON of releases fetched without it); `rule_graph.toJSON()` gives the JSON the service used to send.
 */
export const fetchRelease = async (id: string): Promise<Release> =>
  releaseWithWorkingGraph((await releaseService.getOne(id, { graph: "dg" })) as any);
